module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/return_icon-42da99f9d0dd5173aa647b3715e2c6d9.png";